<div class="screen-assignment" *ngIf="schedules && schedules.length">
<div class="screen-header"> <mat-icon class="playlist-icon" svgIcon="monitor"></mat-icon><span>{{ screen.MonitorTitle }}</span></div>

  <div class="playlist-content" *ngFor="let schedule of schedules"
  [ngClass]="{'non-active': !schedule.On}"
  matTooltip="Edit schedule" (click)="edit(schedule)" matRipple>
    <mat-icon class="playlist-icon" svgIcon="schedule"></mat-icon>
    <span class="schedule-title">{{ schedule.Playlist.PlaylistTitle }}</span>
    <span class="schedule-time">{{ schedule.AllDay? 'All day': schedule.StartTime.split('.')[0] }}</span>
  </div>
</div>
